export const ENVIRONMENT = process.env.REACT_APP_ENV || "development";
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || "";
